export const PLOTLY_THEME_DEFAULTS = {
  margin: 50,
  // Top-margin floor: Plotly centres the figure title in this band, so it needs more room than the sides.
  marginTop: 70,
  legendMinWidth: 300,
  // Breathing room kept between the blocks that share the top margin, and above the topmost one.
  topMarginGap: 8,
  // Plotly's base font size, and the multiple it derives an unstyled figure title from (measured 12→17,
  // 16→22, 20→28, 28→39); an unstyled annotation takes the base size as-is.
  baseFontSize: 12,
  titleFontScale: 1.4,
  // Line box a text block renders as a multiple of its font size, and how far a line drops below its baseline.
  textLineHeightRatio: 1.35,
  titleDescenderRatio: 0.3,
  textColor: "#333333",
  textSecondaryColor: "rgba(0, 0, 0, 0.7)",
  dividerColor: "rgba(0, 0, 0, 0.12)",
  bgColor: "#ffffff",
}

// Dark-scheme chrome fallbacks (mirror the app's darkPalette) — used ONLY when the active scheme's palette
// (theme.colorSchemes[scheme].palette) can't be resolved (e.g. tests); prod reads the resolved theme colors.
export const PLOTLY_THEME_DEFAULTS_DARK = {
  textColor: "#f0f0f0",
  textSecondaryColor: "rgba(255, 255, 255, 0.72)",
  dividerColor: "rgba(255, 255, 255, 0.09)",
  bgColor: "#181818",
}

export const AXIS_LAYOUT_KEY_PATTERN = /^(xaxis|yaxis)\d*$/
